<script lang="ts">
  import { rateLabels } from "../lang";
  import Input from "./Input.svelte";

  let currentTax: string;
  let measurementAmount: string;

  $: result = getResult(currentTax, measurementAmount);

  function getResult(a: string, b: string): string {
    if (!a || !b) {
      return "";
    }

    const calculation = (Number(a) / Number(b)) * 100;

    if (Number.isNaN(calculation) || calculation === Infinity) {
      return "—";
    }

    return `${Math.round(calculation).toString()} %`;
  }
</script>

<div class="u-size-i-350 u-space-b-32">
  <Input
    label={rateLabels.currentTaxLabel}
    info={rateLabels.currentTaxInfo}
    inputmode="numeric"
    bind:value={currentTax}
  />

  <Input
    label={rateLabels.measurementAmountLabel}
    info={rateLabels.measurementAmountInfo}
    inputmode="numeric"
    bind:value={measurementAmount}
  />

  <Input label={rateLabels.resultLabel} value={result} readonly />
</div>
